export type HasTargetStore = { targetStore?: string | null; variantId?: string };

const DEV = process.env.NODE_ENV !== 'production';

export function ensureStoreScope<T extends HasTargetStore[]>(
  items: T | null | undefined,
  store?: string,
  where = 'unknown'
): T {
  if (!DEV || !items?.length || !store) return (items ?? []) as T;

  const foreign = items.filter((i) => i?.targetStore && i.targetStore !== store);
  if (foreign.length) {
    // fail loudly: you want to catch the FIRST place this happens
    // throw new Error(`[STORE-SCOPE VIOLATION] @${where}: found foreign targetStore(s) for store=${store} → ${foreign.map(f => `${f.targetStore}:${f.variantId}`).join(',')}`);
    // or, if you prefer logs first:
    // eslint-disable-next-line no-console
    console.error('[STORE-SCOPE VIOLATION]', { where, store, foreign });
  }
  return items as T;
}
